import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './server/interceptor';
import './styles/reset.less';
import './permissions';
import 'vant/lib/index.css';

createApp(App).use(router).mount('#app')
